module.exports = __webpack_public_path__ + "img/6.aa5f1b5e.png";